import { useRef } from "react";
import { useEditHelperWardMutation, useGetWardsQuery, } from "./wardSlice";


const EditHelperWard = ({ refOpen, editHelper, setEditHelper }) => {
       const {
            data: wards,
            isSuccess,
            isError,
            error
        } = useGetWardsQuery('getWards');

    const [edithelperData, { isLoading }] = useEditHelperWardMutation()

    const handleChange = (e) => {
        setEditHelper({ ...editHelper, [e.target.name]: e.target.value })
    }
    const refCloseHelper = useRef(null)

    const handleClick = async (e) => {
        e.preventDefault()
        try {
            refCloseHelper.current.click();
            await edithelperData({ helper_id: editHelper?.helper_id, helper_name: editHelper?.helper_name, h_leave: editHelper?.h_leave, h_blocked: editHelper?.h_blocked, h_ward_id: editHelper?.h_ward_id }).unwrap()
            setEditHelper({ helper_id: "", helper_name: "", h_leave: "", h_blocked: "", h_ward_id: "" });
        }
        catch (e) {
            console.log("Error in community edit", e)
        }
    }
    return (
        <>
            <button ref={refOpen} type="button" className="btn d-none" data-bs-toggle="offcanvas" data-bs-target="#depOffCanvas1" aria-controls="depOffCanvas1"></button>

            <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="-1" id="depOffCanvas1" aria-labelledby="depOffCanvas1">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Edit Helper</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref={refCloseHelper}></button>
                </div>
                <div className="offcanvas-body">
                    <div>
                        <form className="row g-3">
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="community_name"
                                    name="helper_name"
                                    value={editHelper?.helper_name}
                                    onChange={handleChange}
                                    placeholder="Name"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    Leave
                                </label>
                                <select className="form-select" value={editHelper?.h_leave}
                                    onChange={handleChange}
                                    id="community_type" name="h_leave" required>
                                    <option value="">--Select--</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    Blocked
                                </label>
                                <select className="form-select" value={editHelper?.h_blocked}
                                    onChange={handleChange}
                                    id="community_type" name="h_blocked" required>
                                    <option value="">--Select--</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    ward id
                                </label>
                                <select className="form-select" value={editHelper?.h_ward_id}
                                    onChange={handleChange}
                                    id="community_type" name="h_ward_id" required>
                                    <option value="">--Select--</option>
                                    {/* <option value="4cd2">50</option>
                                    <option value="a0f5">93</option> */}
                                      {wards?.ids?.map((e) => {
                                        return <option value={wards?.entities[e]?.ward_id}>{wards?.entities[e]?.ward_number}</option>
                                    })}
                                </select>
                            </div>

                            <div className="col-md-12">
                                <button type="submit" className="btn btn-ff9b44 btn-block btn-round"
                                    onClick={handleClick}
                                >
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditHelperWard